module.exports = __webpack_public_path__ + "static/media/angular.aba9a682.png";